import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapTrifold, ArrowUpRight } from "@phosphor-icons/react";
import api from "@/lib/api";
import { money } from "@/components/demand/DemandTable";

export default function DemandMapCard() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/demand-map", { params: { days: 30 } }).then((r) => setData(r.data)).catch(() => {}); }, []);
  if (!data) return null;
  return (
    <div className="brut-card p-5" data-testid="dashboard-demand-card">
      <div className="flex items-center gap-2">
        <MapTrifold size={18} weight="bold" />
        <div className="font-chivo font-bold uppercase tracking-tight">Funnel demand · last 30 days</div>
        <Link to="/admin/demand-map" className="ml-auto text-[11px] uppercase tracking-widest border border-black px-2 py-1 hover:bg-black hover:text-white transition-colors duration-100" data-testid="dashboard-demand-open">
          Open map <ArrowUpRight className="inline" size={12} />
        </Link>
      </div>
      <div className="flex gap-6 mt-3">
        <div><div className="label-mono">Unmatched leads</div><div className="font-chivo font-black text-3xl" data-testid="dashboard-demand-unmatched">{data.totals.unmatched}</div></div>
        <div><div className="label-mono">Est. missed revenue</div><div className="font-chivo font-black text-3xl" data-testid="dashboard-demand-missed">{money(data.totals.est_missed)}</div></div>
      </div>
      <ul className="mt-3 space-y-1 text-sm font-mono" data-testid="dashboard-demand-top">
        {data.rows.slice(0, 3).map((r) => (
          <li key={`${r.state}-${r.funnel}-${r.case_type}`} className="flex justify-between border-b border-zinc-200 pb-1">
            <span className="truncate mr-2">{r.state} · {r.funnel_title} · {r.case_label}</span>
            <span className="font-bold">{r.unmatched}</span>
          </li>
        ))}
        {!data.rows.length && <li className="label-mono">Every shared-funnel lead found a buyer.</li>}
      </ul>
    </div>
  );
}
